import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
interface SolutionProps {
  scrollToPricing: () => void;
}
export const Solution: React.FC<SolutionProps> = ({
  scrollToPricing
}) => {
  return <section className="py-20 bg-barre-pink text-white" data-id="element-128">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-130">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-131">
            La solución no es trabajar más horas, es trabajar más inteligente.
          </h2>
          <p className="text-xl md:text-2xl text-barre-blush mb-12 max-w-3xl mx-auto" data-id="element-132"></p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12 text-left" data-id="element-133">
            <div className="bg-white/10 p-6 rounded-2xl backdrop-blur-sm border border-white/20" data-id="element-134">
              <CheckCircle2 className="w-8 h-8 text-barre-blush mb-4" data-id="element-135" />
              <h3 className="text-xl font-bold mb-2" data-id="element-136">
                Sin formaciones eternas
              </h3>
              <p className="text-white/90" data-id="element-137">
                Material directo al grano para que empieces a implementar hoy
                mismo.
              </p>
            </div>
            <div className="bg-white/10 p-6 rounded-2xl backdrop-blur-sm border border-white/20" data-id="element-138">
              <CheckCircle2 className="w-8 h-8 text-barre-blush mb-4" data-id="element-139" />
              <h3 className="text-xl font-bold mb-2" data-id="element-140">Adaptado a Argentina</h3>
              <p className="text-white/90" data-id="element-141">
                Estrategias reales de precios, costos y marketing para nuestro
                contexto.
              </p>
            </div>
            <div className="bg-white/10 p-6 rounded-2xl backdrop-blur-sm border border-white/20" data-id="element-142">
              <CheckCircle2 className="w-8 h-8 text-barre-blush mb-4" data-id="element-143" />
              <h3 className="text-xl font-bold mb-2" data-id="element-144">Paso a paso claro</h3>
              <p className="text-white/90" data-id="element-145">
                Desde qué barra comprar hasta cómo venderle a tus alumnas
                actuales.
              </p>
            </div>
          </div>

          <button onClick={scrollToPricing} className="bg-white text-barre-pink hover:bg-barre-blush font-bold py-4 px-8 rounded-full shadow-lg transition-all transform hover:-translate-y-1 text-lg" data-id="element-146">
            QUIERO VER QUÉ INCLUYE
          </button>
        </motion.div>
      </div>
    </section>;
};